import DataSection from '../../form/dataSection/DataSection'
import BottomFixedModal from '../bottomFixedModal/BottomFixedModal'
import Blank from '../../empty/blank/Blank'
import styles from './onboarding.module.scss'

export const Onboarding = ({
	isShow,
	hideModal,
	number,
	title,
	topDesc,
	content,
	className,
	zIndex,
}: {
	isShow: boolean
	hideModal: () => void
	number?: number
	title?: string | React.ReactNode
	topDesc?: string | React.ReactNode
	content: React.ReactNode
	className?: string
	zIndex?: number
}) => {
	return (
		<BottomFixedModal
			isShow={isShow}
			hideModal={hideModal}
			className={`${styles['onboarding']} ${className ? className : ''}`}
			zIndex={zIndex}
		>
			<DataSection
				title={
					<>
						{number && (
							<div className={styles['number-box']}>
								<span className={styles['number']}>{number}</span>
							</div>
						)}
						{title}
					</>
				}
				titleSize='large'
				topDesc={topDesc || ''}
				noPadding={true}
			>
				<>
					<Blank height={16} />
					{content && content}
				</>
			</DataSection>
		</BottomFixedModal>
	)
}
